import { render } from "./addcontent.vue?vue&type=template&id=18bbf9d2"
import script from "./addcontent.vue?vue&type=script&lang=js"
export * from "./addcontent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__